import { requestRecalculateCompleteness } from 'legacy/lut/features/partner360/completeness'
import { selectFinancialYear, selectPartnerId } from 'legacy/lut/features/partner360/configuration'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

/**
 * Triggers completeness recalculation for a partner.
 *
 * Note: We only dispatch requestRecalculateCompleteness here. The commitment statuses
 * are automatically refreshed by the listener at:
 * legacy/lut/features/partner360/commitment/listeners/recalculateCompletenessListener.ts
 * which listens to requestRecalculateCompleteness.fulfilled and dispatches
 * requestCommitmentStatuses and requestCommitmentItems.
 */
export const useRecalculateCompleteness = () => {
  const dispatch = useAppDispatch()

  const partnerId = useSelector(selectPartnerId)
  const fYear = useSelector(selectFinancialYear)

  const recalculateCompleteness = useCallback(async () => {
    if (!partnerId || !fYear) {
      return
    }

    const parameters = { partnerId, fYear }

    await dispatch(requestRecalculateCompleteness(parameters)).unwrap()
  }, [dispatch, partnerId, fYear])

  return recalculateCompleteness
}
